/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, pxToEmWithBaseline, replacePXinStringWithEM, convertHexToRGB, animation } from 'utils/styles';



/* ++++++++++ --------------- USER DATA COLLECTION STYLES --------------- ++++++++++ */
export default {
    udcentryphase: {
        '& .headertext': {
            display: 'block',
            overflow: 'hidden',
            height: pxToEm(90),
            // maxHeight: pxToEm(90), // if we want the field and checkbox to flow up directly underneath the desc if it's less than this specified height
            width: '100%',
            marginTop: pxToEmWithBaseline({ value: 5, fontSizeBaseline: 24 }),
            '& .title': {
                fontSize: '100%', // this gets auto adjusted based on if this overflows it's parent container via the component file
                lineHeight: 1,
                fontWeight: 'bold',

                // animation
                transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
                animationName: 'fadeInLeft',
                animationDelay: '0s',
                animationDuration: '.4s',
                animationFillMode: 'forwards',

                '& .titletext': {
                    fontSize: pxToEmWithBaseline({ value: 24, fontSizeBaseline: 16 }),
                }
            },
            '& .desc': {
                fontSize: pxToEmWithBaseline({ value: 14, fontSizeBaseline: 16 }),
                lineHeight: pxToEmWithBaseline({ value: 16, fontSizeBaseline: 14 }),
                fontWeight: 500,
                marginTop: pxToEmWithBaseline({ value: 8, fontSizeBaseline: 14 }),

                // animation
                transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
                animationName: 'fadeInLeft',
                animationDelay: '0.1s',
                animationDuration: '.3s',
                animationFillMode: 'forwards',
            }
        },
        '& .label': {
            fontSize: pxToEmWithBaseline({ value: 12, fontSizeBaseline: 16 }),
            lineHeight: pxToEmWithBaseline({ value: 16, fontSizeBaseline: 12 }),
            fontWeight: 'bold',
            marginTop: pxToEm(10),

            // animation
            transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
            animationName: 'fadeInLeft',
            animationDelay: '0.15s',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
        },
        '& .field': {
            backgroundColor: `rgba(0, 0, 0, 0.2)`,
            border: replacePXinStringWithEM(`1px solid ${color.white}`),
            borderRadius: pxToEm(3),
            color: color.greyMedium,
            fontSize: pxToEm(16),
            lineHeight: 1,
            width: '100%',
            height: pxToEm(34),
            marginTop: pxToEm(6),
            marginBottom: pxToEm(14),
            boxSizing: 'border-box',
            maxWidth: pxToEm(280),
            paddingLeft: pxToEm(8),
            transition: 'background .2s linear 0s',
            overflow: 'hidden', // helps with button animation
            textAlign: 'right',

            // animation
            transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
            animationName: 'fadeInLeft',
            animationDelay: '0.2s',
            animationDuration: '.2s',
            animationFillMode: 'forwards',

            '&:hover': {
                backgroundColor: `rgba(0, 0, 0, 0.4)`,
            },
            '& .input': {
                backgroundColor: 'transparent',
                border: 'none',
                color: color.white,
                fontSize: pxToEm(14),
                fontWeight: 500,
                width: '100%',
                height: '100%',
                outline: 'none',
                '&::placeholder': {
                  color: 'rgba(255, 255, 255, .35)'
                }
            },
            '&.isValid-true': {
                fontSize: 'bold'
            },
            '&.isValid-false': {
                background: convertHexToRGB(color.red, 50)
            }
        },
        '& .checkboxgroup': {
            '& .checkboxwrapper': {
                '&:first-child': {
                    // animation
                    transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
                    animationName: 'fadeInLeft',
                    animationDelay: '0.25s',
                    animationDuration: '.2s',
                    animationFillMode: 'forwards',
                },
                '&:last-child': {
                    // animation
                    transform: 'translate3d(-200%, 0, 0)', // pull off screen to start
                    animationName: 'fadeInLeft',
                    animationDelay: '0.3s',
                    animationDuration: '.2s',
                    animationFillMode: 'forwards',
                }
            }
        },
        '& .ctas': {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: pxToEmWithBaseline({ value: 15, fontSizeBaseline: 16 }),
            // marginTop: pxToEmWithBaseline({ value: 26, fontSizeBaseline: 16 }),
            '& .skip': {
                '&.styletype-transparent': {
                    animationDelay: '0.3s',
                }
            }
        }
    }
};
